export default "__VITE_ASSET__DTlPSu9f__"